let LineupGenerator = {
    GENERATOR_TYPE_FRONTEND: 'GENERATOR_TYPE_FRONTEND',
    GENERATOR_TYPE_BACKEND_V1: 'GENERATOR_TYPE_BACKEND_V1',
    GENERATOR_TYPE_BACKEND_V2: 'GENERATOR_TYPE_BACKEND_V2',
    GENERATOR_TYPE_BACKEND_V3: 'GENERATOR_TYPE_BACKEND_V3',

    SET_GENERATOR_TYPE: 'SET_GENERATOR_TYPE',

    SET_SHOW_PLAYERS_EXPOSURE_WHILE_OPTIMIZED: 'SET_SHOW_PLAYERS_EXPOSURE_WHILE_OPTIMIZED',
    SET_RELAX_BUILD_RULES: 'SET_RELAX_BUILD_RULES',
};

LineupGenerator.GENERATOR_TYPE_COMMON_DEFAULT_VALUES = LineupGenerator.GENERATOR_TYPE_FRONTEND;
LineupGenerator.GENERATOR_TYPE_DEFAULT_VALUES = {
    nba: {
        classic: LineupGenerator.GENERATOR_TYPE_BACKEND_V1,
    },
    nfl: {
        classic: LineupGenerator.GENERATOR_TYPE_FRONTEND,
    },
    nhl: {
        classic: LineupGenerator.GENERATOR_TYPE_BACKEND_V1,
    },
};

export default LineupGenerator;
